import React from 'react'
import moment from "moment";
import {component_tool} from '@/tool'
import {WizClassifySelect, WizClassifySelectRe, WizTableForm} from '@/containers/common';

const userConfig = WizTableForm.Config.user(this, {apiParams: {state: 1}})
//配置项
let componentName = 'operateRecord'
let ref;
let entity = {
  type: 'diy',
  links: {'bizType': '业务类型'},
  ...WizTableForm.Config.program(this, {}),
  changePopsFunction: (
    linksValues
  ) => {
    const {bizType} = linksValues
    let config;
    if (bizType === 20) {
      config = WizTableForm.Config.content()
    } else if (bizType === 1) {
      config = WizTableForm.Config.program()
    } else if (bizType === 24) {
      config = WizTableForm.Config.invitation()
    } else {
      config = null
    }
    return config
  },
  diy: WizTableForm,
  selectType: 'radio',
}

let fromEntity = Object.assign({
  rules: [{
    required: true,
    message: '请选择操作人',
  }]
}, entity)

const columns = (operateData) => {
    return [
      {
        name: "id",
        formItem: {
          type: "hidden"
        }
      },
      {
        name: "createBy",
        formItem: {
          type: "hidden",
        }
      },
      {
        name: "createTime",
        formItem: {
          type: "hidden",
        }
      },
      //列表展示
      {
        title: "操作人",
        name: "operatePersonName",
        dataIndex: "operatePersonName",
        tableItem: {}
      },
      {
        title: '操作时间',
        name: 'operateTime',
        dataIndex: 'operateTime',
        tableItem: {},
      },
      {
        title: '操作类型',
        name: 'operateType',
        dataIndex: 'operateType',
        dict: [
          {code: 0, codeName: "无操作"},
          {code: 1, codeName: "点赞"},
          {code: 2, codeName: "踩"}
        ],
        tableItem: {},
      },
      //搜索条件
      {
        title: "关联实体类型",
        name: "bizType",
        dataIndex: "bizType",
        tableItem: {},
        dict: [
          {code: 24, codeName: "帖子"},
          {code: 20, codeName: "内容"},
          {code: 1, codeName: "课程"}
        ],
        searchItem: {
          type: "select",
          initialValue: operateData.bizType
        },
        formItem: {
          type: "select",
          rules: [{
            required: true,
            message: '请选择关联类型',
          }]
        }
      },
      {
        title: '关联实体',
        name: 'bizId',
        searchItem: {
          type: 'diy',
          links: {'bizType': '业务类型'},
          ...WizTableForm.Config.program(this, {}),
          changePopsFunction: (
            linksValues
          ) => {
            const {bizType} = linksValues
            let config;
            if (bizType === 20) {
              config = WizTableForm.Config.content()
            } else if (bizType === 1) {
              config = WizTableForm.Config.program()
            } else if (bizType === 24) {
              config = WizTableForm.Config.invitation()
            } else {
              config = null
            }
            return config
          },
          diy: WizTableForm,
          selectType: 'radio',
          initialValue: operateData.bizId,
          formatInit: (record) => {
            return operateData.bizId
          },
          initRows: [{...operateData, id: operateData.bizId, name: operateData.bizName, content: operateData.bizName}]
        },
        formItem: fromEntity
      },
      {
        title: '操作类型',
        name: 'operateType',
        dataIndex: 'operateType',
        dict: [
          {code: 1, codeName: "点赞"},
          {code: 2, codeName: "踩"}
        ],
        formItem: {
          type: "select",
          rules: [{
            required: true,
            message: '请选择操作类型',
          }]
        },
      },
      {
        title: "操作人",
        name: "operatePerson",
        dataIndex: "operatePerson",
        searchItem: {
          ...userConfig,
          diy: WizTableForm,
          selectType: 'radio',
        },
        formItem: {
          ...userConfig,
          diy: WizTableForm,
          selectType: 'radio',
          rules: [{
            required: true,
            message: '请选择操作人',
          }]
        },
      },
      {
        title: '操作时间',
        name: 'operateTime',
        dataIndex: 'operateTime',
        searchItem: {
          type: 'date~',
          showTime: true,
        }
      },
      {
        name: "startDate",
        formItem: {
          type: "hidden"
        }
      },
      {
        name: "endDate",
        formItem: {
          type: "hidden"
        }
      }
    ]
  }
;

const templateConfig = (data) => {
  let {operateData} = data
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(operateData),
        searchBarProps: {
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (v) => {
            let fitterValues = {};
            Object.keys((v)).forEach(key => {
              const value = v[key];
              if (key === 'operateTime' && value != null && value != undefined) {
                fitterValues['startDate'] = value[0].format("YYYY-MM-DD HH:mm:ss");
                fitterValues['endDate'] = value[1].format("YYYY-MM-DD HH:mm:ss");
              } else if (value != null && value != undefined) {
                fitterValues[key] = value;
              }
            });
            return fitterValues
          },
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          // selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort: [],
        commonOperate: {
          add: true,
        },
        rowOperateView: []
      }
    }
  }
};

const apis = (operateData) => {
  return {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {
          pageNum: 1,
          pageSize: 10,
          bizType: operateData?.bizType || null,
          operateType: operateData?.operateType || null,
          bizId: operateData?.bizId || null
        }
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    }
  };
}

let reduxTemplateCofig = (args) => {
  let {operateData} = args
  return {
    apis: apis(operateData),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
